module.exports = __webpack_public_path__ + "img/image1.057b8b31.png";